export const commonProps = {
	id: String,
	component: String,
	disabled: Boolean,
	dataTest: { type: String, required: false },
}

export const multiProps = Object.assign(
	{
		options: Object,
		searchable: Boolean,
		labelField: String,
		valueField: String,
	},
	commonProps,
)
